import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Pricing, Demo, Offer, FunderAllocation } from "./pages";
import { RequireGroup } from "./components";
import {
    FunderListSection,
    FunderDetailSection,
    LoanListSection,
    LoanDetailSection,
    GlobalAuditSection,
} from "./sections/funder-allocation";
const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Pricing />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/offer" element={<Offer />} />
                <Route
                    path="/funder-allocation"
                    element={
                        <RequireGroup group="settlement">
                            <FunderAllocation />
                        </RequireGroup>
                    }
                >
                    <Route index element={<Navigate to="loans" replace />} />
                    <Route path="loans" element={<LoanListSection />} />
                    <Route
                        path="loans/:loanId"
                        element={<LoanDetailSection />}
                    />
                    <Route path="funders" element={<FunderListSection />} />
                    <Route
                        path="funders/:funderId"
                        element={<FunderDetailSection />}
                    />
                    <Route path="audit" element={<GlobalAuditSection />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
